// Product category landing pages (/products/:slug). Product cards come from products.js
// via categoryId; this file holds the search-focused copy for each category page.
// `image` is a photo of that product range (null → `icon` tile instead; see components/Icon.js).
// `heroBg` is the static photo behind the page header.
// Stock photos (Unsplash License — free for commercial use, no attribution required):
//   cat-acoustic.jpg  https://unsplash.com/photos/J4Ticm2cX34
//   cat-ladders.jpg   https://unsplash.com/photos/eJ3TTxG-CmE
//   cat-tools.jpg     https://unsplash.com/photos/wwZYL4BYFto

export const PRODUCT_BASE_PATH = '/products';

export const productPages = [
  {
    slug: 'ceilings',
    heroBg: '/images/bg-supertec.jpg',
    summary: 'Ceiling boards, tiles, exposed & plaster grid',
    image: '/images/cat-ceilings.jpg',
    icon: 'grid',
    categoryId: 'ceiling',
    name: 'Ceilings',
    heading: 'Ceiling Supplies in George',
    title: 'Ceiling Supplier in George — Boards, Tiles & Suspended Grid',
    description:
      'Ceiling supplier in George: ceiling boards, ceiling tiles, suspended exposed grid (white, black & grey) and plaster grid. Garden Route delivery.',
    keywords: [
      'ceiling suppliers George',
      'ceiling supplies George',
      'ceiling boards George',
      'ceiling tiles George',
      'suspended ceiling grid suppliers',
      'exposed grid ceiling',
      'plaster grid ceiling',
      'ceiling brandering',
      'Nutec ceiling boards',
      'ceiling tiles 600x600',
      'plafonne George',
    ],
    intro: [
      'OJANNA Ceiling & Drywall Distributors is a specialist ceiling supplier in George, stocking everything you need for suspended ceilings, plastered ceilings and ceiling board installations. We are master distributor for SuperTec, ETEX, Siniat and OWA, so contractors get dependable stock and sharp project pricing.',
      'Choose from vinyl and acoustic ceiling tiles, exposed grid systems in white, black and grey, plaster grid with aluminium profiles for seamless ceilings, plus steel brandering, Nutec fibre cement ceiling boards, fasteners and tools. We deliver ceiling supplies from Plettenberg Bay to Cape Town and into the Klein Karoo.',
    ],
    faq: [
      {
        q: 'Do you supply suspended ceiling grid in George?',
        a: 'Yes. We stock exposed (suspended) ceiling grid systems in white, black and grey, with compatible ceiling tiles from OWA and SuperTec, for collection in George or delivery across the Western and Eastern Cape.',
      },
      {
        q: 'What is the difference between exposed grid and plaster grid ceilings?',
        a: 'Exposed grid ceilings use a visible T-grid that holds drop-in ceiling tiles, ideal for offices and retail where you need access above the ceiling. Plaster grid is a concealed system: plasterboard is fixed to the grid and jointed and skimmed for a smooth, seamless ceiling.',
      },
    ],
  },
  {
    slug: 'drywall-partitioning',
    heroBg: '/images/bg-siniat.jpg',
    summary: 'Gyproc RhinoBoard, Siniat & SuperTec boards, brandering',
    image: '/images/cat-drywall.jpg',
    icon: 'wall',
    categoryId: 'drywall',
    name: 'Drywall & Partitioning',
    heading: 'Drywall & Plasterboard Supplies in George',
    title: 'Drywall Supplier in George — Plasterboard & Partitioning',
    description:
      'Drywall supplier in George: Gyproc RhinoBoard, Siniat & SuperTec plasterboard, steel brandering, studs & tracks. Delivered across the Garden Route.',
    keywords: [
      'drywall suppliers George',
      'drywall supplies George',
      'plasterboard George',
      'plasterboard prices George',
      'gypsum board George',
      'rhino board George',
      'Gyproc RhinoBoard',
      'moisture resistant gypsum board',
      'drywall partitioning',
      'steel brandering',
      'drywall studs and tracks',
      'droëmure George',
    ],
    intro: [
      'Looking for drywall suppliers in George? OJANNA Ceiling & Drywall Distributors stocks complete drywall and partitioning systems: plasterboard (gypsum board) from Gyproc — including RhinoBoard — Siniat and SuperTec, steel brandering, tracks, studs, nogging, aluminium profiles and all the fixings and jointing products to finish the job.',
      'Our plasterboard range includes standard, moisture-resistant, fire-resistant and impact-resistant boards for walls, ceilings, bulkheads and wet areas. Ask our sales team for current plasterboard prices and project quotes — we deliver across the Garden Route, Western Cape and Eastern Cape.',
    ],
    faq: [
      {
        q: 'Which plasterboard brands do you stock?',
        a: 'We supply plasterboard from Saint-Gobain Gyproc, Siniat and SuperTec, including standard, moisture-resistant and fire-resistant boards.',
      },
      {
        q: 'Rhino board or Nutec — which ceiling board should I use?',
        a: 'Gypsum boards like Gyproc RhinoBoard give a smooth, paintable ceiling for most interiors, with moisture-resistant versions for bathrooms and humid areas. Fibre cement boards such as Nutec and RhinoROC are unaffected by moisture and rot-proof, so they suit covered patios, eaves and exposed areas. Ask us which suits your project.',
      },
      {
        q: 'Can I get a price on plasterboard and drywall materials?',
        a: 'Yes. Call 064 531 9070, email info@ojanna.co.za or use our contact form with your quantities and we will send a quote, including delivery if needed.',
      },
    ],
  },
  {
    slug: 'insulation',
    heroBg: '/images/bg-isover.jpg',
    summary: 'Aerolite, Isover, Isotherm, Knauf & Youngman',
    image: '/images/cat-insulation.jpg',
    icon: 'waves',
    categoryId: 'insulation',
    name: 'Insulation',
    heading: 'Ceiling & Roof Insulation in George',
    title: 'Roof & Ceiling Insulation Supplier in George',
    description:
      'Roof & ceiling insulation in George: Aerolite (Think Pink), Isover, Isotherm, Knauf & Youngman. SANS 10400-XA advice. Garden Route delivery.',
    keywords: [
      'roof insulation George',
      'ceiling insulation George',
      'insulation supplier Garden Route',
      'Aerolite insulation',
      'Think Pink insulation',
      'Aerolite Soft Touch',
      'Isotherm insulation',
      'Youngtherm',
      'Knauf Insulation',
      'SANS 10400-XA insulation',
      'isolasie George',
    ],
    intro: [
      'Insulation is one of the most effective ways to make a home or building more energy efficient. OJANNA Ceiling & Drywall Distributors supplies ceiling and roof insulation in George from Knauf Insulation, Isotherm, Aerolite (formerly Think Pink, now Aerolite Soft Touch), Isover and Youngman Roofing & Insulation — including Youngtherm, Acoustisorb, Lambdaboard and radiant barriers.',
      'Our owner, Niel Kasselman, is an accredited Green Building Council Professional and can help you choose insulation that meets SANS 10400-XA energy requirements for new builds, or the best upgrade for an existing roof.',
    ],
    faq: [
      {
        q: 'Which insulation is best for my ceiling?',
        a: 'It depends on your roof type, climate and budget. Glasswool blankets such as Aerolite are laid between the ceiling joists, Isotherm is a polyester insulation made from recycled PET bottles, and radiant barriers work under the roof sheeting. SANS 10400-XA sets a minimum total R-value for the roof assembly, so speak to our team for a recommendation for your building.',
      },
      {
        q: 'What happened to Think Pink insulation?',
        a: 'Aerolite Think Pink is now sold as Aerolite Soft Touch — the same glasswool ceiling insulation without the pink dye. We stock Aerolite along with Isotherm, Knauf Insulation, Isover and Youngman products.',
      },
      {
        q: 'Do you deliver insulation to Oudtshoorn and the Klein Karoo?',
        a: 'Yes. We deliver insulation and ceiling supplies from George to Oudtshoorn, Calitzdorp, De Rust, Prince Albert and surrounding areas.',
      },
    ],
  },
  {
    slug: 'acoustic-panels',
    heroBg: '/images/bg-acoustic.jpg',
    summary: 'WoodUpp acoustic wall panels & OWA acoustic ceilings',
    image: '/images/cat-acoustic.jpg',
    icon: 'sound',
    categoryId: 'acoustic',
    name: 'Acoustic Panels & Ceilings',
    heading: 'Acoustic Panels & Acoustic Ceilings',
    title: 'Acoustic Panels, Wall Panels & Acoustic Ceiling Tiles',
    description:
      'Acoustic panels in George: WoodUpp Akupanel wood slat wall panels and OWA acoustic ceiling tiles for offices, studios & venues. Delivered.',
    keywords: [
      'acoustic panels George',
      'acoustic panels South Africa',
      'acoustic wall panels',
      'wood slat acoustic panels',
      'WoodUpp Akupanel',
      'acoustic panels Garden Route',
      'acoustic ceiling tiles',
      'OWA ceiling tiles',
      'sound absorbing panels',
    ],
    intro: [
      'OJANNA Ceiling & Drywall Distributors is master distributor for Speciality Design Concepts (OWA) and also distributes WoodUpp Akupanel acoustic wall panels — giving you premium options for acoustic walls and ceilings.',
      'Use acoustic wall panels and acoustic ceiling tiles to control echo and noise in offices, boardrooms, studios, restaurants, churches, schools and auditoriums, with finishes that look as good as they perform.',
    ],
    faq: [
      {
        q: 'Where can I buy WoodUpp acoustic panels in the Garden Route?',
        a: 'OJANNA Ceiling & Drywall Distributors in George distributes WoodUpp Akupanel acoustic wall panels and can deliver across the Garden Route and Western Cape.',
      },
    ],
  },
  {
    slug: 'plasters',
    heroBg: '/images/bg-casofour.jpg',
    summary: 'Skimming & jointing — Siniat, Casofour; iTe skim & patch',
    image: '/images/cat-plasters.jpg',
    icon: 'brush',
    categoryId: 'plasters',
    name: 'Plasters',
    heading: 'Skimming Plaster & Jointing Compound in George',
    title: 'Skimming Plaster & Jointing Compound in George',
    description:
      'Skimming plaster & jointing compound in George from Siniat and Casofour, plus iTe skim coats & patching. Collect or get it delivered.',
    keywords: [
      'skimming plaster George',
      'jointing compound',
      '90 minute jointing compound',
      'Siniat plaster',
      'Casofour plaster',
      'iTe DURALiTe skim coat',
      'PATCHiTe',
    ],
    intro: [
      'Get a flawless finish on ceilings and drywall with professional gypsum skimming and jointing plasters from Siniat and Casofour, available from OJANNA Ceiling & Drywall Distributors in George.',
      'We stock 90-minute setting jointing compound for faster turnaround, plus skim coats and patching products for repairs and renovations.',
      'For cement-based work we also stock iTe DURALiTe skim coat for interior and exterior walls, and PATCHiTe rapid-set patching compound for floor screed repairs.',
    ],
    faq: [],
  },
  {
    slug: 'ladders-door-frames',
    heroBg: '/images/bg-warehouse.jpg',
    summary: 'MecoLadder ladders, SuperTec & Swartland frames',
    image: '/images/cat-ladders.jpg',
    icon: 'ladder',
    categoryId: 'access',
    name: 'Ladders & Door Frames',
    heading: 'Aluminium Ladders & Door Frames in George',
    title: 'Aluminium Ladders & Door Frames in George',
    description:
      'Aluminium ladders in George: MecoLadder A-frame, extension & multi-purpose ladders, plus SuperTec & Swartland door frames and glazing sections.',
    keywords: [
      'aluminium ladders George',
      'MecoLadder',
      'A-frame ladder',
      'extension ladder',
      'drywall door frames',
      'aluminium glazing sections',
    ],
    intro: [
      'OJANNA Ceiling & Drywall Distributors stocks MecoLadder aluminium ladders — A-frame step ladders, extension, single and multi-purpose ladders — for trade and household use.',
      'For drywall partitions we supply SuperTec aluminium door frame and glazing sections for clean, glazed office partitions, and we also carry Swartland door frames and Kenzo aluminium windows and doors.',
    ],
    faq: [],
  },
  {
    slug: 'tools-fasteners',
    heroBg: '/images/bg-shellwhite.jpg',
    summary: 'Drywall screws, anchors, rivets & clips',
    image: '/images/cat-tools.jpg',
    icon: 'tools',
    categoryId: 'accessories',
    name: 'Tools & Fasteners',
    heading: 'Drywall Screws, Tools & Fasteners in George',
    title: 'Drywall Screws, Tools & Fasteners in George',
    description:
      'Drywall screws, anchors, rivets, ceiling clips and ceiling & drywall tools in George, from OJANNA Ceiling & Drywall Distributors.',
    keywords: ['drywall tools George', 'drywall screws', 'ceiling clips', 'rivets and anchors'],
    intro: [
      'Complete your ceiling or drywall project with professional tools and fasteners from OJANNA Ceiling & Drywall Distributors: drywall screws, anchors, rivets, ceiling clips and the tools for cutting, fixing and finishing.',
    ],
    faq: [],
  },
];

export const getProductPageBySlug = (slug) => productPages.find((p) => p.slug === slug);
export const getProductPageByCategory = (categoryId) =>
  productPages.find((p) => p.categoryId === categoryId);
export const productPagePath = (page) => `${PRODUCT_BASE_PATH}/${page.slug}`;
